<template>
  <section class="product_sec">
    <div class="product_grid tmb-product-modifier">
      <div class="product_grid_image line-h-0 modify-slider">
        <div class="tmb_sliderNew">
          <Fancybox :options="fancyboxOptions">
            <Splide
              data-splide='{
                "perPage": 1,
                "paginationDirection": "ttb",
                "direction": "ttb",
                "heightRatio": 1,
                "speed":800,
                "breakpoints": { "991": { "direction": "ltr" } }
              }'
              class="tmb_splide"
            >
              <SplideSlide
                v-for="(value, key) in selectedProduct.media"
                :key="key"
                class="product_slide swiper-zoom-container"
              >
                <a
                  data-fancybox="gallery"
                  :href="extractSrc(value)"
                  class="product_media"
                  v-html="sanitizeHtml(value)"
                />
              </SplideSlide>
            </Splide>
            <div class="tmb-splide-pagination" />
          </Fancybox>
        </div>
      </div>
      <div class="product_grid_content">
        <h1 class="product_title card_heading">
          {{ selectedProduct.title }}
        </h1>

        <h2 v-if="!selectedProduct.title.includes('Gift Card')" class="product_price">
          <span>
            <del v-if="selectedProduct.compare_at_price && selectedProduct.price">
              {{ currencySymbol }}{{ (selectedProduct.compare_at_price / 100).toFixed(2) }}
            </del>
          </span>

          <span class="discounted_price">
            {{
              `${currencySymbol}${
                Number.isInteger(selectedProduct.price / 100)
                  ? '' + (selectedProduct.price / 100).toFixed(2)
                  : ' ' + (selectedProduct.price / 100).toFixed(2)
              }`
            }}
          </span>

          <!-- Calculate and display the discount percentage -->
          <span
            v-if="selectedProduct.compare_at_price && selectedProduct.price"
            class="discount-percentage"
          >
            {{
              Math.round(
                ((selectedProduct.compare_at_price - selectedProduct.price) /
                  selectedProduct.compare_at_price) *
                  100
              )
            }}% off
          </span>
        </h2>
        <div v-if="!selectedProduct.title.includes('Gift Card')" class="mainReviews">
          <span v-pre class="reviewStars">
            <svg
              width="86"
              height="13"
              viewBox="0 0 257 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21 1L25.7148 15.5106H40.9722L28.6287 24.4787L33.3435 38.9894L21 30.0213L8.65651 38.9894L13.3713 24.4787L1.02781 15.5106H16.2852L21 1Z"
                fill="black"
              />
              <path
                d="M74 1L78.7148 15.5106H93.9722L81.6287 24.4787L86.3435 38.9894L74 30.0213L61.6565 38.9894L66.3713 24.4787L54.0278 15.5106H69.2852L74 1Z"
                fill="black"
              />
              <path
                d="M129 1L133.715 15.5106H148.972L136.629 24.4787L141.343 38.9894L129 30.0213L116.657 38.9894L121.371 24.4787L109.028 15.5106H124.285L129 1Z"
                fill="black"
              />
              <path
                d="M183 0.5L187.715 15.0106H202.972L190.629 23.9787L195.343 38.4894L183 29.5213L170.657 38.4894L175.371 23.9787L163.028 15.0106H178.285L183 0.5Z"
                fill="url(#paint0_linear_1_2)"
              />
              <path
                d="M236 1L240.715 15.5106H255.972L243.629 24.4787L248.343 38.9894L236 30.0213L223.657 38.9894L228.371 24.4787L216.028 15.5106H231.285L236 1Z"
                fill="#E8E7E3"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1_2"
                  x1="162"
                  y1="21.6868"
                  x2="202"
                  y2="22"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.5249" />
                  <stop offset="0.525" stop-color="#E8E7E3" />
                </linearGradient>
              </defs>
            </svg>
          </span>
          <a class="totalReviews" href="#review_section">
            <span class="totalReviewsNumber">0 </span> REVIEWS
          </a>
        </div>
        <form id="productForm" method="post" @submit="onAddtoCart">
          <!-- <p class="after_pay">
            or 4 interest-free installments of $97.50 by<img src="https://cdn.shopify.com/s/files/1/0577/1178/8125/files/afterpay.png?v=1653477636">
          </p> -->
          <!-- 
         <ul class="product_variant">
            <li
              v-for="(value, key) in sortedArray"
              :id="value.name"
              :key="key"
              class="color_variant_wrap"
              :class="value.name"
              @click="changePath(value.link)"
            >
              <input
                :id="value.name"
                type="radio"
                class="color_variant"
                :checked="currentUrl == value.link"
              />
              <label v-if="value.img != ''" class="color_variant_label" :for="value.name">
                <div class="tooltip">{{ value.name.replace(/_/g, ' ') }}</div>
                <img v-lazy="value.img" :alt="value.img.alt || 'Product Image'" />
              </label>
            </li>
          </ul> -->
          <!-- Product variant swatches -->
          <ul
            v-if="!selectedProduct.title.includes('Gift Card')"
            class="product_variant"
            role="radiogroup"
            aria-label="Color Variants"
          >
            <li
              v-for="value in sortedArray"
              :key="value.name"
              class="color_variant_wrap"
              :class="[value.name, currentUrl == value.link ? 'active' : '']"
              aria-label="Color Variant"
              @click="changePath(value.link)"
            >
              <input
                :id="'color_' + value.name"
                type="radio"
                class="color_variant"
                name="color-variant-group"
                role="radio"
                aria-label="Color Variant"
                :checked="currentUrl == value.link"
                :aria-checked="currentUrl == value.link"
              />

              <label
                v-if="value.img"
                class="color_variant_label"
                :for="'color_' + value.name"
                :aria-label="'Select color ' + value.name.replace(/_/g, ' ')"
              >
                <div class="tooltip">
                  {{ value.name.replace(/_/g, ' ') }}
                </div>

                <!-- <img
                  :src="value.img"
                  :alt="'Color variant: ' + value.name.replace(/_/g, ' ')"
                  height="24"
                  width="24"
                  style="aspect-ratio: 1/1;"
                /> -->
                <picture>
                  <!-- WebP -->
                  <source
                    :srcset="`${value.img}&format=webp&width=24&height=24&crop=center`"
                    type="image/webp"
                  />

                  <!-- JPG fallback -->
                  <source
                    :srcset="`${value.img}&width=24&height=24&crop=center`"
                    type="image/jpeg"
                  />

                  <img
                    :src="`${value.img}&width=24&height=24&crop=center`"
                    width="24"
                    height="24"
                    aria-label="Color Variant Image"
                    class="color_swatch_img"
                    :alt="value.name.replace(/_/g, ' ') + ' Color Variant Image'"
                  />
                </picture>
              </label>
            </li>
          </ul>

          <div
            v-if="
              selectedProduct && selectedProduct.variants && selectedProduct.variants.length > 1
            "
            class="select"
          >
            <label v-if="!selectedProduct?.title?.includes('Gift Card')" id="selectSize"
              >Select Size</label
            >
            <h2
              v-if="selectedProduct?.title?.includes('Gift Card')"
              class="select-size-text product_price"
            >
              {{ tempSize || selectedSize }}
            </h2>
            <ul class="swatchs_warraper">
              <li v-for="(value, key) in selectedProduct.variants" :key="key">
                <template v-if="value.inventory_quantity >= 1">
                  <input
                    :id="value.title"
                    type="radio"
                    class="size_variant"
                    name="size"
                    :value="value.id"
                    aria-label="Size Variant"
                    :checked="value.title === selectedSize"
                  />
                  <label
                    v-if="value.title != ''"
                    class="size_variant_label"
                    :class="{ active: value.title === selectedSize }"
                    :for="value.title"
                    aria-label="Size Variant"
                    @mouseenter="sizeSelect(value.title, 'hover')"
                    @mouseleave="sizeSelect('Select Size', 'leave')"
                    @click="sizeSelect(value.title, 'click')"
                    v-html="sanitizeHtml(value.title)"
                  />
                </template>
                <!-- Disable Size Option -->
                <template v-else>
                  <input
                    :id="value.title"
                    type="radio"
                    class="size_variant"
                    name="size"
                    :value="value.id"
                    disabled
                    aria-label="Size Variant"
                  />
                  <label
                    v-if="value.title != ''"
                    class="size_variant_label disable"
                    :for="value.title"
                    aria-label="Size Variant"
                    @mouseenter="sizeSelect(value.title, 'soldOut')"
                    @mouseleave="sizeSelect('Select Size', 'leave')"
                    v-html="sanitizeHtml(value.title)"
                  />
                </template>
              </li>
            </ul>
          </div>
          <p v-if="currentVariantQty == 0" class="product_left subtitle_b">SOLD OUT</p>
          <p v-else-if="currentVariantQty <= 5" class="product_left subtitle_b">
            ONLY {{ currentVariantQty }} LEFT
          </p>
          <input name="id" :value="selectedProduct.variants[0].id" type="hidden" />
          <input id="quantity" min="1" type="number" name="quantity" value="1" hidden />
          <div class="add_cart_btn_wrap">
            <button
              v-if="currentVariantQty > 0"
              id="AddToCart"
              type="submit"
              name="add"
              data-label="Add to Bag"
              class="add_cart_btn cta_btn cta_btn-black"
              aria-label="Add to Bag"
            >
              ADD TO BAG
              <div class="loder_tmb"><span /><span /> <span /><span /> <span /></div>
            </button>
            <button
              v-if="currentVariantQty == 0"
              id="OutOfStock"
              type="button"
              name="out"
              data-label="Sold Out"
              class="add_cart_btn cta_btn cta_btn-outstock"
              aria-label="Sold Out"
            >
              SOLD OUT
            </button>
            <span class="tmb_bottomInfo mobile"> Free shipping across USA. </span>
            <span class="tmb_bottomInfo-desktop"> -Free shipping across USA. </span>
          </div>
        </form>

        <div class="product_description_data">
          <!-- Product Description -->
          <!-- eslint-disable -->
          <div
            class="product_description"
            aria-label="Product Description"
            v-html="replaceString(selectedProductDescription[0])"
          />
          <!-- eslint-enable -->

          <!-- Product Description subscription components -->
          <template v-if="shopifyDataResolved.showSubscribeSection">
            <p class="subscribe_text" aria-label="Subscribe Text">
              {{ shopifyDataResolved.subscribeText }}
            </p>
            <div class="subscribe_input">
              <div id="subscribe" class="klaviyo-form-TzvfPL" />
            </div>
          </template>

          <!-- Product Description seen in and featured in feild-->
          <template v-if="metaFieldSeenIn && metaFieldSeenIn.some((item) => item.src)">
            <p class="feature_in">FEATURED IN:</p>
            <div class="see_in">
              <div
                v-for="(seenIn, index) in metaFieldSeenIn.filter((item) => item.src)"
                :key="index"
                class="see_in_image"
              >
                <img
                  :src="seenIn.src"
                  :alt="seenIn.alt || 'Featured In Image'"
                  aria-label="Featured In Image"
                  loading="lazy"
                  width=""
                  height=""
                />
              </div>
            </div>
          </template>

          <!-- Product Description custom comment feild-->
          <template v-if="metaFieldReviewText?.length > 0">
            <div class="product_description product_description-comment">
              <p class="quote">“{{ metaFieldReviewText?.split('name')[0] }}”</p>
              <p class="quote_auther">- {{ metaFieldReviewText?.split('name')[1] }}</p>
            </div>
          </template>

          <!-- PROMISES POINTS -->
          <ul class="promises_points">
            <li class="promises_title" v-html="sanitizeHtml(shopifyDataResolved.pointInfoTitle)" />
            <li
              v-for="(item, index) in shopifyDataResolved.pointInfo"
              :key="index"
              class="list_item"
            >
              <!-- <img class="promise_img" :src="item.pointImage" /> -->
              <span class="promise_point" v-html="sanitizeHtml(item.pointText)" />
            </li>
          </ul>

          <!-- Product Accordians -->
          <ul class="product_accordians">
            <!-- Product Details -->

            <li v-if="selectedProductDescription[1]" class="product_accordian">
              <button
                class="accodian d-flex w-100"
                aria-label="Details"
                @click="
                  (event) => {
                    accordion(event);
                  }
                "
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" y="0.5" width="12" height="12" fill="white" stroke="black" />
                </svg>

                DETAILS
              </button>
              <!-- eslint-disable -->
              <div
                class="product_accordian_panel"
                v-html="replaceString(selectedProductDescription[1])"
              />
              <!-- eslint-enable -->
            </li>

            <!-- Product Specification -->
            <li v-if="selectedProductDescription[2]" class="product_accordian">
              <button
                class="accodian d-flex w-100"
                aria-label="Specs"
                @click="
                  (event) => {
                    accordion(event);
                  }
                "
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" y="0.5" width="12" height="12" fill="white" stroke="black" />
                </svg>

                SPECS
              </button>
              <!-- eslint-disable -->
              <div
                class="product_accordian_panel"
                v-html="replaceString(selectedProductDescription[2])"
              />
              <!-- eslint-enable -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section v-if="metaFieldGrid.metaFieldsData" class="product_page_grid_wrap">
    <div class="product_page_grid">
      <div class="product_page_grid_item product_page_grid_item-first">
        <img
          v-if="metaFieldGrid.metaFieldsData?.img?.src"
          v-lazy="metaFieldGrid.metaFieldsData.img.src"
          loading="lazy"
          aria-label="Product Image"
          width=""
          height=""
          :src-placeholder="metaFieldGrid.metaFieldsData?.img?.placeholder"
          :alt="metaFieldGrid.metaFieldsData?.img?.alt || 'Product Image'"
        />
        <div class="product_page_grid_content">
          <h3
            v-if="metaFieldGrid.metaFieldsData.gridLeftHeading"
            class="product_grid_heading subtitle_b"
            v-html="sanitizeHtml(metaFieldGrid.metaFieldsData.gridLeftHeading)"
          />
          <p
            v-if="metaFieldGrid.metaFieldsData.gridLeftPara"
            class="caption"
            v-html="sanitizeHtml(metaFieldGrid.metaFieldsData.gridLeftPara)"
          />
        </div>
      </div>
      <div class="product_page_grid_item product_page_grid_item-second">
        <img
          v-lazy="metaFieldGrid.RightGridImage.src"
          :src-placeholder="metaFieldGrid.RightGridImage.placeholder"
          :alt="metaFieldGrid.RightGridImage.alt || 'Product Image'"
          loading="lazy"
          aria-label="Product Image"
          width=""
          height=""
        />
        <div class="product_page_grid_content">
          <h3
            class="product_grid_heading subtitle_b"
            v-html="sanitizeHtml(metaFieldGrid.RightGridHeading)"
          />
          <p class="caption" v-html="sanitizeHtml(metaFieldGrid.RightGridpara)" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from 'vue';

// Import Splide library
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import '@splidejs/splide/dist/css/splide.min.css';
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes

import Fancybox from './fancybox';

import { ShopifyAPI } from '../../../Shopify/Shopify';

// import required modules
import { currencyJson } from '@/currency';

export default {
  components: {
    Fancybox,
    Splide,
    SplideSlide,
  },
  props: {
    shopifyData: {
      type: Object,
      required: false,
    },
    shopifyDataEncoded: {
      type: String,
      required: false,
    },
  },
  setup() {
    const thumbsSwiper = ref(null);
    const setThumbsSwiper = (swiper) => {
      thumbsSwiper.value = swiper;
    };
    return {
      thumbsSwiper,
      setThumbsSwiper,
    };
  },

  data() {
    // Decode shopifyDataEncoded if provided, otherwise use shopifyData
    let shopifyDataResolved = {};
    if (this.shopifyDataEncoded) {
      try {
        const decoded = atob(this.shopifyDataEncoded);
        shopifyDataResolved = JSON.parse(decoded);
      } catch (error) {
        console.error('Error decoding shopifyDataEncoded in data():', error);
        shopifyDataResolved = this.shopifyData || {};
      }
    } else {
      shopifyDataResolved = this.shopifyData || {};
    }

    function b64_to_utf8(str) {
      if (!str || typeof str !== 'string') return '[]';
      try {
        // check if string is valid base64
        if (/^[A-Za-z0-9+/=]+$/.test(str.trim())) {
          const decoded = window.atob(str);
          return decodeURIComponent(escape(decoded));
        } else {
          console.warn('Non-base64 input detected, returning as-is');
          return str;
        }
      } catch (error) {
        console.error('Error decoding base64:', error);
        return '[]';
      }
    }

    let variant = [];
    let productObj = [];

    try {
      variant = b64_to_utf8(shopifyDataResolved.productData?.variant || '');
      variant = JSON.parse(variant);
      console.log(' == variant', variant);
    } catch (error) {
      console.error('Error parsing variant:', error);
      variant = [];
    }

    try {
      productObj = b64_to_utf8(shopifyDataResolved.productData?.product || '');
      // let pointInfo = shopifyDataResolved;
      // console.log(pointInfo, " == pointInfo ===");

      productObj = JSON.parse(productObj);
    } catch (error) {
      console.error('Error parsing product:', error);
      productObj = [];
    }
    // console.log(productObj, " == product======");

    const product = [];
    if (Array.isArray(productObj)) {
      productObj.map((item) => {
        if (item && item.product && !item.product.error) {
          product.push(item.product);
        }
      });
    }

    if (Array.isArray(variant)) {
      variant = variant.filter((item) => {
        return item && item.qty != '';
      });
    }

    if (Array.isArray(productObj)) {
      productObj = productObj.filter((item) => {
        return item && item.product_media && item.product_media.length != 0;
      });
    }
    //

    const currentUrl = window.location.pathname;

    // if(currentUrl?.includes('collections')){
    //   let changeUrl = currentUrl.split('/products/');
    //   currentUrl = `/products/${changeUrl[1]}`
    // }

    // console.log(currentUrl, "currentUrl====currentUrl");

    const path = currentUrl.split('/products/')[1];
    const filterProduct =
      product.length > 0 ? product.filter((item) => item.handle == path)[0] : null; // filter product by current path
    const index = product.findIndex((x) => x.handle === path);

    console.log(index, ' ====== product');

    const metaFieldSeenIn = productObj[index]?.meta_field_seen || [];
    const metaFieldReviewText = productObj[index]?.reviewText || '';

    const metaFieldGrid = productObj[index]?.meta_field_grid || {};
    // console.log(metaFieldGrid,"=========metaFieldGrid")

    const mediaGrid = productObj[index]?.product_media || [];
    // console.log(mediaGrid,"=========mediaGrid")

    if (filterProduct) {
      filterProduct.media = mediaGrid;
    }

    console.log(variant, currentUrl);

    const filterVariant = Array.isArray(variant)
      ? variant.filter((item) => item && item.link == currentUrl)[0]
      : null; // filter variant by current path

    return {
      selectedSize: '',
      tempSize: '',

      showProductReviewData: [],
      variant: variant || [],
      fivestar: 5,
      product: productObj,
      metaFieldSeenIn,
      metaFieldReviewText,
      metaFieldGrid,
      selectedProduct: filterProduct || { title: '', description: '', media: [], handle: '' },
      currentUrl,
      selectedProductDescription:
        filterProduct && filterProduct.description
          ? filterProduct.description.split('<!-- split -->')
          : [],
      currentVariantQty: parseInt(filterVariant?.qty || 0),
      reviewResponse: '',
      currencySymbol: currencyJson[window?.Shopify?.currency?.active]?.symbol_native,
      fancyboxOptions: {},
      name: '',
      email: '',
      reviewTitle: '',
      reviewDiscription: '',
    };
  },
  computed: {
    shopifyDataResolved() {
      // If encoded data is provided, decode it
      if (this.shopifyDataEncoded) {
        try {
          const decoded = atob(this.shopifyDataEncoded);
          return JSON.parse(decoded);
        } catch (error) {
          console.error('Error decoding shopifyDataEncoded:', error);
          return this.shopifyData || {};
        }
      }
      // Otherwise return the regular shopifyData prop
      return this.shopifyData || {};
    },
    sortedArray() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      // Create a copy of the variant array before sorting
      return [...this.variant].sort(compare);
    },
  },
  mounted() {
    // ===============================
    // JUDGEME PDP REVIEW FIX
    // ===============================

    const updateReviews = () => {
      const customStars = document.querySelector('.reviewStars');
      const customTotal = document.querySelector('.totalReviewsNumber');

      const jdgmStars = document.querySelector('.jdgm-rev-widg__summary-stars');
      const jdgmCount = document.querySelector('.jdgm-rev-widg__summary-text');

      if (customStars && customTotal && jdgmStars && jdgmCount) {
        customStars.innerHTML = jdgmStars.innerHTML;
        customTotal.textContent = jdgmCount.textContent.replace(/[^0-9]/g, '');
        return true;
      }
      return false;
    };

    const showReviewSection = () => {
      const section = document.querySelector('#review_section');
      const widget = document.querySelector('.jdgm-rev-widg');
      if (section && widget) {
        section.style.display = 'block'; // show only when Judge.me widget is ready
        return true;
      }
      return false;
    };

    // Polling every 300ms until Judge.me loads fully
    const interval = setInterval(() => {
      const visible = showReviewSection();
      const updated = updateReviews();

      if (visible && updated) {
        clearInterval(interval);
      }
    }, 300);

    // Auto-stop after 6 seconds (performance safety)
    setTimeout(() => clearInterval(interval), 6000);

    function slideValue() {
      // Fetch the total number of slides and set them in the 'slides' array
      const splideSlides = document.querySelector('.splide__slide.product_slide.is-active');
      const pagination = document.querySelector('.tmb-splide-pagination');
      const ariaLabelValue = splideSlides.getAttribute('aria-label');
      const slideInfo = ariaLabelValue.replace(' of ', ' / ');
      pagination.innerHTML = slideInfo;
    }

    window.addEventListener('load', () => {
      setTimeout(() => {
        slideValue();
      }, 700);
    });
    const slideButtons = document.querySelectorAll('button.splide__arrow');
    slideButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          slideValue();
        }, 700);
      });
    });

    window.addEventListener('load', () => {
      console.log(this.shopifyDataResolved, 'prduct');
    });
    this.currencySymbol = currencyJson[window?.Shopify?.currency?.active]?.symbol_native;
    // this.getProductReview();
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 991) {
        const footerContent = document.querySelector('.footer_content');
        const addCartBtn = document.querySelector('.add_cart_btn_wrap');
        if (footerContent && addCartBtn) {
          footerContent.style.paddingBottom = `${addCartBtn.offsetHeight}px`;
        }
        // document.querySelector(".footer_wave").style.backgroundColor = document.querySelector(".tmbMain").style.backgroundColor = "#f1f1f1";
      } else {
        const footerContent = document.querySelector('.footer_content');
        const footerWave = document.querySelector('.footer_wave');
        const tmbMain = document.querySelector('.tmbMain');
        if (footerContent) footerContent.style.paddingBottom = `0`;
        if (footerWave && tmbMain) {
          footerWave.style.backgroundColor = tmbMain.style.backgroundColor = 'transparent';
        }
      }
    });

    if (window.innerWidth <= 991) {
      const footerContent = document.querySelector('.footer_content');
      const addCartBtn = document.querySelector('.add_cart_btn_wrap');
      if (footerContent && addCartBtn) {
        footerContent.style.paddingBottom = `${addCartBtn.offsetHeight}px`;
      }
      // document.querySelector(".footer_wave").style.backgroundColor = document.querySelector(".tmbMain").style.backgroundColor = "#f1f1f1";
    }
    const getemptyData = document.querySelector('.product_page_grid_wrap ');
    if (getemptyData) {
      getemptyData.setAttribute('id', `${getemptyData.innerText ? '' : 'TmbemptyGrid'}`);
    }
    const qualityAccordion = document.querySelector('.quality-accordion');
    // const reviewSection = document.querySelector('.review_section');
    if (qualityAccordion) qualityAccordion.style.display = 'block';

    // Set default selectedSize to first available variant
    if (
      this.selectedProduct &&
      this.selectedProduct.variants &&
      this.selectedProduct.variants.length > 1
    ) {
      const isGiftCard = this.selectedProduct?.title?.includes('Gift Card');

      if (isGiftCard) {
        // For Gift Card, always select first variant (no inventory check needed)
        this.selectedSize = this.selectedProduct.variants[0]?.title || '';
      } else {
        // For regular products, select first available variant
        const firstAvailableVariant = this.selectedProduct.variants.find(
          (variant) => variant.inventory_quantity >= 1
        );
        if (firstAvailableVariant) {
          this.selectedSize = firstAvailableVariant.title;
        }
      }
    }
  },

  methods: {
    containsImgTag(value) {
      return value.includes('<img');
    },
    extractSrc(value) {
      const match = value.match(/src=['"](.*?)['"]/);
      console.log(match, 'match');
      return match ? match[1] : '';
    },

    hasWhiteSpace(s) {
      return /\s/.test(s);
    },

    async onAddtoCart(e) {
      e.preventDefault();

      const form = e.target;

      // find button add acctive class
      form.querySelector('button[type="submit"]').classList.add('active');

      const dynamic = new ShopifyAPI();
      let item;
      const sizeVariant = document.querySelectorAll('.size_variant_label');
      if (sizeVariant?.length > 1) {
        item = {
          id: document.querySelector('.size_variant:checked').value,
          qty: 1,
        };
      } else {
        item = {
          id: this.selectedProduct.variants[0].id,
          qty: 1,
        };
      }
      await dynamic.addItem(item);
      form.querySelector('button[type="submit"]').classList.remove('active');
    },
    sizeSelect(size, type) {
      const isGiftCard = this.selectedProduct?.title?.includes('Gift Card');

      if (type == 'click') {
        this.selectedSize = size;
      }
      // For Gift Card, don't show hover effect - only click works
      if (!isGiftCard) {
        if (type == 'hover') {
          this.tempSize = size;
        }
        if (type == 'leave') {
          this.tempSize = '';
        }
        if (type == 'soldOut') {
          this.tempSize = 'Sold Out';
        }
      }
    },
    changePath(link) {
      // console.log(SwiperSlide)
      const path = link.split('/products/')[1];
      // let selectedProductReviewData = this.productReviewData.filter(item => item.link == link)[0];
      this.showProductReviewData = [];
      const filterVariant = this.variant.filter((item) => item.link == link)[0]; // filter variant by current path
      const product = this.product.map((item) => {
        return item.product;
      });
      this.selectedProduct = product.filter((item) => item.handle == path)[0];
      const index = product.findIndex((x) => x.handle === path);
      const metaFieldSeenIn = this.product[index].meta_field_seen;
      // let metaFieldReviewText = this.product[index].reviewText;
      const metaFieldGrid = this.product[index].meta_field_grid;
      const mediaGrid = this.product[index].product_media;
      this.selectedProduct.media = mediaGrid;
      this.metaFieldSeenIn = metaFieldSeenIn;
      this.metaFieldGrid = metaFieldGrid;
      this.currentUrl = link;
      this.selectedProductDescription = this.selectedProduct.description.split('<!-- split -->');
      this.currentVariantQty = parseInt(filterVariant.qty);
      // Reset selectedSize to first available variant when product changes
      if (this.selectedProduct.variants && this.selectedProduct.variants.length > 1) {
        const isGiftCard = this.selectedProduct?.title?.includes('Gift Card');

        if (isGiftCard) {
          // For Gift Card, always select first variant
          this.selectedSize = this.selectedProduct.variants[0]?.title || '';
        } else {
          // For regular products, select first available variant
          const firstAvailableVariant = this.selectedProduct.variants.find(
            (variant) => variant.inventory_quantity >= 1
          );
          this.selectedSize = firstAvailableVariant ? firstAvailableVariant.title : '';
        }
      } else {
        this.selectedSize = '';
      }
      // this.getProductReview();
      window.history.replaceState('', '', link);
      const swiper = document.querySelector('.swiper').swiper;
      swiper.realIndex = 0;
      swiper.initialSlide = 0;
      swiper.init(swiper.el);
      swiper.visibleSlidesIndexes = [0];
      swiper.slideTo(1, 10, false);
    },

    sanitizeHtml(html) {
      if (!html) return '';
      return String(html)
        .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // remove script tags
        .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ''); // remove style tags
    },
    replaceString(data) {
      if (!data) return '';
      data = data.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, ''); // remove script tags
      data = data.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, ''); // remove style tags
      data = data.replace(/Â/g, '');
      return data;
    },
    accordion(event) {
      const accodian = event.currentTarget;
      const accodianPanel = accodian.nextElementSibling;
      const activeAccodianPanel = document.querySelector('.accodian.active');
      if (activeAccodianPanel) {
        activeAccodianPanel.classList.remove('active');
        activeAccodianPanel.nextElementSibling.setAttribute('style', `height: 0px;`);
      }
      if (activeAccodianPanel != accodian) {
        accodianPanel.setAttribute('style', `height: ${accodianPanel.scrollHeight}px;`);
        accodian.classList.add('active');
      }
    },
  },
};
</script>
<style>
.tmb_sliderNew > div {
  position: relative;
}

.tmb-splide-pagination {
  position: absolute;
  right: 0;
  bottom: 10px;
  color: #777777;
  font-size: 12px;
  letter-spacing: 0.01em;
}

.tmb_splide .splide__arrows--ttb .splide__arrow--prev {
  top: 44%;
  left: 96%;
  transform: unset;
  transform: rotate(90deg);
}

.tmb_splide .splide__arrow {
  position: relative;
}

.tmb_splide .splide__arrow::after {
  position: absolute;
  content: '';
  background: url(https://cdn.shopify.com/s/files/1/0577/1178/8125/files/left-arrow-new.svg?v=1654580925);
  background-repeat: no-repeat;
  background-position: center center;
  height: 32px;
  width: 32px;
  z-index: 4;
  border-radius: 50%;
  margin: 0;
  background-color: #fff;
}

.tmb_splide .splide__arrows--ttb .splide__arrow--next {
  bottom: 44%;
  top: auto;
  left: 96%;
  transform: unset;
  transform: rotate(-90deg);
}

.tmb_splide .splide__arrows.splide__arrows--ttb {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  right: 34px;
  z-index: 1;
  display: flex;
  gap: 50px;
  flex-direction: column;
}

.tmb_splide .splide__pagination--ttb {
  display: none;
  bottom: 0;
  left: 95%;
  right: 0;
  top: 0;
}

.tmb_splide .splide__pagination__page {
  background: #e8e7e3;
  width: 5.65px;
  height: 5.65px;
}

.tmb_splide .splide__pagination__page.is-active {
  background: #272727;
  transform: scale(1);
}

.product_price {
  display: flex;
  gap: 5px;
}

img {
  touch-action: auto;
}

.add_review_accordion {
  display: none;
}

/* .product_sec .swiper-slide, */

.promises_points {
  margin: 23px 0;
}

.promises_points .promises_title {
  font-weight: 700;
  margin-bottom: 11px;
  font-family: 'Helvetica Neue', sans-serif;
}

.promises_points .list_item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.promises_points .list_item:not(:last-child) {
  margin-bottom: 10px;
}

.promises_points .promise_point {
  font-weight: 400;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 14px;
  letter-spacing: 0.02em;
  line-height: 16.7px;
}

.product_sec .swiper-slide img {
  touch-action: pinch-zoom !important;
}

.tmb_bottomInfo {
  font-weight: 400;
  padding: 15px;
  text-align: center;
  font-size: 15px;
  letter-spacing: 0.02em;
  display: block;
  color: #000000;
  background-color: #e8e7e3;
}

.tmb_bottomInfo-desktop {
  margin: 14px 0 19px;
  display: block;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 17.89px;
  text-align: left;
}

.discount-percentage {
  color: red;
  /* font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em; */
  text-transform: uppercase;
  font-weight: 700;
}

.tmb_bottomInfo.mobile {
  display: none;
}

.jdgm-paginate {
  display: none;
}

.reviewStars {
  max-width: 88px;
  width: 100%;
  display: flex;
}

button#AddToCart {
  position: relative;
}

.product_slide,
.product_zoom {
  background: #fff;
}

.product_media {
  height: 100%;
  display: inline-block;
  cursor:
    url('https://cdn.shopify.com/s/files/1/1000/3130/files/18dddcc9cf53b547eaf0f76c308502f6.svg?v=1633015103')
      16 16,
    auto;
}

.product_media video {
  max-width: 100%;
  object-fit: contain;
}

.product_media > * {
  height: 100%;
  object-fit: cover;
}

/* Product Zoom css Start */
.product_zoom {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  min-height: 100vh;
  overflow-y: scroll;
  z-index: -2;
  opacity: 0;
  visibility: hidden;
  touch-action: pan-y pinch-zoom;
}

.product_zoom.active {
  z-index: 6;
  opacity: 1;
  visibility: visible;
  touch-action: pan-y pinch-zoom;
}

.product_zoom .swiper-button-prev {
  left: 80px;
}

.product_zoom .swiper-button-next {
  right: 80px;
}

.product_zoom .product_media {
  line-height: 0;
  max-width: 1200px;
  margin: 0 auto;
  cursor:
    url('https://cdn.shopify.com/s/files/1/1000/3130/files/x.svg?v=1633016418') 16 16,
    auto;
}

.mainReviews {
  max-width: 195px;
  width: 100%;
  display: flex;
  align-items: center;
  margin: 15px 0 15.85px;
  gap: 20px;
}

.mainReviews svg {
  display: block;
}

.totalReviews {
  text-transform: uppercase;
  text-decoration: underline;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.02em;
  line-height: 14.32px;
}

.jdgm-star.jdgm--half:before {
  content: '\e002';
}

/* Product Zoom css End */

.product-media-slider .swiper-pagination-fraction {
  position: absolute;
  bottom: 15px;
  left: auto;
  width: fit-content;
  right: 20px;
  z-index: 2;
}

.product-media-slider .swiper-pagination-fraction,
.product-media-slider .swiper-pagination-fraction span {
  color: #777777;
  font-size: 12px;
  letter-spacing: 0.01em;
}

.product-media-slider .swiper-button-prev {
  right: 15px;
  left: auto;
  transform: translateY(-100%) rotate(90deg);
}

.product-media-slider .swiper-button-next {
  transform: translateY(100%) rotate(-90deg);
}

.product_description_data .Ehic-Content li {
  display: flex;
  gap: 15px;
  margin-bottom: 10px;
}

.product_description_data .Ehic-Content li:last-child {
  margin-bottom: 0;
}

.product_description_data .Ehic-Content img {
  height: 42px;
  width: 42px;
}

.product_description_data * {
  /* font-family: "adobe-caslon-pro", sans-serif; */
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  color: #000 !important;
}

.product_description-comment p {
  font-family: 'Big Caslon', serif !important;
  font-size: 13px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;
}

.product_description-comment .quote_auther {
  font-family: 'Helvetica Neue', Arial, sans-serif !important;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  margin-top: 5px;
}

.product_review {
  max-height: 440px !important;
  overflow-y: scroll;
  border: none;
  margin-top: 10px;
}

.product_accordian_panel > ul {
  padding: 15px 0;
  border-bottom: 1px solid #000;
}

.product_accordian_panel > ul > li {
  padding-left: 5px;
}

.product_sec .swiper-wrapper {
  height: auto !important;
}

.productZoom.active .swiper-slide .swiper-button-prev,
.productZoom.active .swiper-slide .swiper-button-next {
  position: fixed !important;
}

@media only screen and (max-width: 1440px) {
  /* product zoom Start */
  .product_zoom .swiper-button-prev {
    left: 18px;
  }

  .product_zoom .swiper-button-next {
    right: 18px;
  }

  /* product zoom End */
}

@media only screen and (max-width: 991px) {
  .product_grid_image.modify-slider {
    position: relative;
  }

  /* .product_media,
  .product_media > * {
    height: auto;
  } */

  .product-media-slider {
    position: static;
  }

  .discount-percentage {
    display: block;
    margin-top: 6px;
  }

  .discounted_price {
    margin-left: 10px;
  }

  .product_grid .product-media-slider .swiper-button-prev,
  .product_grid .product-media-slider .swiper-button-next {
    display: none !important;
  }

  .product-media-slider .swiper-pagination {
    top: calc(100% + 12px);
  }

  .product-media-slider .swiper-pagination-bullet {
    margin: 0 2px;
    height: 6px;
    width: 6px;
    background: #e8e7e3;
    opacity: 1;
  }

  .product-media-slider .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: #272727;
  }

  .tmb_bottomInfo.mobile {
    display: none;
  }

  .tmb_bottomInfo-desktop {
    display: none;
  }

  .splide__arrows.splide__arrows--ttb,
  .tmb-splide-pagination {
    display: none !important;
  }

  .tmb_splide .splide__pagination--ttb {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    right: 0;
    top: 100%;
    padding: 0;
    display: flex;
    gap: 0;
    align-items: center;
    justify-content: center;
    margin: 17px 0;
    max-width: 90px;
  }
}

@media only screen and (max-width: 768px) {
  /* .product_grid .swiper-button-next,
  .product_grid.swiper-button-prev {
    display: none !important;
  } */
  .tmb_bottomInfo {
    display: block;
  }

  .mainReviews {
    margin: 15px 0 15.85px;
  }
}

@media only screen and (max-width: 480px) {
  /* product zoom Start */
  .product_zoom .swiper-button-prev,
  .product_zoom .swiper-button-next {
    display: block;
  }

  .splide__arrows.splide__arrows--ltr {
    position: fixed;
    visibility: hidden;
  }

  /* product zoom End */
}

/* Review Css Code */
.jdgm-rev.jdgm-divider-top .jdgm-rev__icon {
  height: 32px;
  width: 32px;
  object-fit: cover;
  padding-top: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.jdgm-rev__buyer-badge-wrapper {
  display: none;
}
</style>
<style scoped>
.product_sec {
  margin: 0;
  padding-top: 26px;
  /* padding-bottom: 30px; */
  padding-bottom: 0;
}

.product_grid {
  display: grid;
  grid-template-columns: 55% 370px;
  gap: 80px;
  padding: 0 15px;
  overflow: hidden;
}

.product-media-slider {
  height: calc(100vh - 110px);
  text-align: center;
}

.product_title {
  line-height: 18px;
}

.product_price {
  font-size: 15px;
  letter-spacing: 0.02em;
  margin: 9px 0;
  line-height: 18px;
}

.product_price del {
  color: #878787;
}

.after_pay {
  font-size: 11px;
  letter-spacing: 0.015em;
}

.after_pay img {
  vertical-align: middle;
}

.product_variant {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0 17px;
}

.color_variant {
  display: none;
}

.color_variant_label {
  cursor: pointer;
  line-height: 0;
  height: fit-content;
  border-radius: 50%;
  display: block;
  box-shadow: 0 0 0 1px #e0e0e0;
  position: relative;
}

.color_variant:checked + .color_variant_label {
  box-shadow:
    0 0 0 2px #fff,
    0 0 0 3px #6b6b6b;
}

.color_variant_label img {
  height: 24px;
  width: 24px;
  border-radius: 50%;
}

.tooltip::after {
  border-left: solid transparent 10px;
  border-right: solid transparent 10px;
  border-top: solid rgba(51, 51, 51, 0.9) 10px;
  bottom: -10px;
  content: ' ';
  height: 0;
  left: 50%;
  position: absolute;
  width: 0;
  transform: translateX(-50%);
}

.tooltip {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  background-color: rgba(51, 51, 51, 0.9);
  color: #fff;
  text-align: center;
  font-size: 12px;
  line-height: 1;
  padding: 5px 10px;
  width: 120px;
  bottom: calc(100% + 15px);
  left: 50%;
  transform: translateX(-50%);
  transition: all 0.25s ease-out;
}

.color_variant_label:hover .tooltip {
  opacity: 1;
  visibility: visible;
}

.product_left {
  line-height: 15px;
  color: #878787;
  margin-bottom: 12px;
}

.add_cart_btn {
  width: 100%;
  padding-block: 15px;
}

.product_description_data {
  margin-top: 16px;
}

.product_description_data p {
  margin: 25px 0 9px;
}

.product_description_data .feature_in,
.product_description_data .subscribe_text {
  color: #000;
  font-family: 'Helvetica Neue', sans-serif !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.24px;
  text-transform: uppercase;
}

.product_description_data .subscribe_text {
  text-transform: none;
  white-space: nowrap;
  font-weight: 400;
}

.product_description_data .subscribe_input .needsclick.kl-private-reset-css-Xuajs1 {
  background-color: transparent !important;
}

.see_in {
  display: inline-flex;
  gap: 20px;
  /* flex-wrap: wrap; */
  align-items: center;
  border-bottom: 1px solid #000;
  padding-bottom: 10px;
  width: 100%;
}

.see_in_image {
  position: relative;
}

.see_in .see_in_image:not(:last-child):after {
  position: absolute;
  content: '';
  background-color: #000;
  height: 24px;
  width: 1px;
  display: block;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
}

.product_description-comment p {
  margin: 0;
  font-family: adobe-caslon-pro, sans-serif;
}

.product_description-comment {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.product_description-comment .quote_auther {
  align-self: flex-end;
}

.quote_owner {
  text-align: end;
}

.product_accordians {
  margin-top: 23px;
  margin-bottom: 87px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.product_accordian {
  margin-top: 5px;
}

.accodian {
  font-family: 'Helvetica Neue', sans-serif;
  position: relative;
  align-items: center;
}

.accodian svg {
  margin-right: 10px;
}

.accodian::after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 6px;
  background: url('https://cdn.shopify.com/s/files/1/0689/7618/1550/files/Vector_11.svg?v=1710760730')
    no-repeat center;
  background-size: 12px;
  transition: 0.3s;
}

.accodian.active::after {
  transform: translateY(-50%) rotate(-180deg);
}

.product_accordian_panel {
  height: 0;
  overflow: hidden;
  transition: 0.3s;
}

.product_accordian_panel li {
  padding-left: 5px;
}

.swatchs_warraper {
  margin-top: 15px;
}
.select .swatchs_warraper {
  margin-top: 23px;
  margin-bottom: 15px;
}

.swatchs_warraper .size_variant {
  display: none;
}

.swatchs_warraper li {
  display: inline-flex;
}

.swatchs_warraper .size_variant_label {
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.02em;
  font-family: 'Helvetica Neue', sans-serif;
  font-style: normal;
  line-height: 21.034px;
  min-width: 40px;
  min-height: 40px;
  cursor: pointer;
  color: #4c4c4b;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid #fafafa;
  background-color: #fafafa;
  text-align: center;
}

.size_variant_label.disable {
  background: #f7f5f5;
  position: relative;
  color: #ccc;
}

.size_variant_label.disable::after {
  content: '';
  background: url('https://cdn.shopify.com/s/files/1/1000/3130/files/Icon_40x.svg?v=1669883133')
    no-repeat;
  position: absolute;
  left: 50%;
  top: 50%;
  height: 40px;
  width: 40px;
  opacity: 0.2;
  transform: translate(-50%, -50%);
}

.swatchs_warraper .size_variant:checked + .size_variant_label {
  border: #6b6b6b 1px solid;
  background-color: #000;
  color: #fff;
}

.swatchs_warraper .size_variant_label:hover {
  border: #6b6b6b 1px solid;
}

@media only screen and (max-width: 1440px) {
  .product-media-slider {
    height: calc(100vh - 106px);
  }

  .product_grid {
    gap: 60px;
  }
}

@media only screen and (max-width: 1440px) {
  .product_grid {
    gap: 40px;
  }
}

@media only screen and (max-width: 991px) {
  .product_sec {
    padding-top: 0;
  }

  .product_accordians {
    margin-bottom: 23px;
  }

  .product_price {
    display: block;
    margin: 14px 0;
  }

  .product_grid {
    padding: 0;
    grid-template-columns: 100%;
    gap: 35px;
  }

  .product_grid_content {
    max-width: 600px;
    padding: 0 15px;
    width: 100%;
    margin: 0 auto;
  }

  .product-media-slider {
    height: auto;
  }

  .product_grid_image {
    position: relative;
  }

  .product_variant {
    margin: 15px 0 25px;
  }

  .product_description_data .feature_in {
    font-size: 14px;
  }

  .product_grid_image::after {
    content: '';
    background: url('https://cdn.shopify.com/s/files/1/0577/1178/8125/files/Magnifying_glass.svg?v=1654078628')
      no-repeat;
    background-size: 18px;
    position: absolute;
    right: 15px;
    bottom: 15px;
    height: 18px;
    width: 18px;
    z-index: 2;
  }

  /* product zoom Start */
  .product_zoom .product_media {
    position: relative;
    height: 100vh;
  }

  .product_zoom .product_media::after {
    content: none;
    position: absolute;
    background: url('https://cdn.shopify.com/s/files/1/0577/1178/8125/files/EXIT_X.svg?v=1654157423')
      no-repeat;
    top: 0;
    left: 0;
    height: 48px;
    width: 48px;
  }

  /* product zoom End */

  .add_cart_btn_wrap {
    /* padding: 0 15px 10px; */
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
  }
}
</style>
<style scoped>
.product_page_grid_wrap {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #e9e7e3 100%);
  padding: 50px 0 130px;
}

.product_page_grid {
  max-width: 820px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
}

.product_page_grid_item-first {
  margin-top: 320px;
}

.product_grid_heading {
  margin: 17px 0 21px;
}

@media only screen and (max-width: 991px) {
  .product_page_grid_wrap {
    padding: 50px 0 80px;
  }

  .product_page_grid {
    gap: 50px;
  }
}

@media only screen and (max-width: 768px) {
  .product_page_grid_wrap {
    padding: 50px 0;
  }

  .product_page_grid {
    grid-template-columns: 1fr;
  }

  .product_page_grid_item {
    text-align: center;
  }

  .product_page_grid_item-first {
    order: 2;
    margin-top: 0;
  }

  .product_page_grid_content {
    padding: 0 12px;
    text-align: left;
  }
}

@media only screen and (max-width: 480px) {
  .product_page_grid_item img {
    width: 100%;
    object-fit: cover;
  }
}
</style>

<!-- css for revoew -->
<style>
.recently_view_sec {
  display: block;
}

.product_review {
  max-width: 1440px;
  padding: 0 !important;
}

.jdgm-rev__header {
  margin-bottom: 5px;
}

.product .jdgm-widget.jdgm-widget .jdgm-rev-widg__header {
  text-align: center;
}

.product .jdgm-widget.jdgm-widget .jdgm-rev-widg__header h2.jdgm-rev-widg__title {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 36px;
}

.content h2 {
  margin-bottom: 0;
}

.jdgm-rev-widg__title {
  visibility: visible !important;
}

.product
  .jdgm-widget.jdgm-widget
  .jdgm-rev-widg__header
  .jdgm-widget-actions-wrapper
  a.jdgm-write-rev-link {
  background: #000;
  padding: 15px;
  width: 210px;
}

.jdgm-rev__icon {
  position: relative;
  float: left;
  width: 3.2em;
  height: 3.2em;
  line-height: 3.2em;
  text-align: center;
  border-radius: 50%;
  margin-right: 14px;
  color: #333333;
  background-color: #e9e9e9;
}

.jdgm-star.jdgm--on {
  padding-right: 3px !important;
}

.jdgm-rev__title {
  display: none !important;
}

.jdgm-quest[data-verified-buyer='true'] .jdgm-rev__icon:not(.jdgm--loading):after,
.jdgm-rev[data-verified-buyer='true'] .jdgm-rev__icon:not(.jdgm--loading):after {
  display: block;
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 9px;
  font-weight: bold;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 15px;
  border: 1px solid white;
  text-align: center;
}

span.jdgm-star {
  color: #363636;
  font-size: 14px;
}

:not(.jdgm-prev-badge__stars) > .jdgm-star {
  color: #585858;
}

.jdgm-star.jdgm--on:before {
  content: '' !important;
  position: static;
}

.jdgm-rev__timestamp + .jdgm-rev__br {
  padding-bottom: 1px;
}

.jdgm-rev__br:empty {
  display: block;
}

.jdgm-rev__icon::after,
.jdgm-rev__buyer-badge {
  display: inline-block;
  color: #ffffff;
  background-color: rgb(0, 123, 255);
}

.jdgm-rev__buyer-badge {
  padding: 3px 7px;
  font-size: 11px;
  line-height: 1;
  vertical-align: middle;
}

.jdgm-rev__buyer-badge:before {
  content: 'Verified';
}

.jdgm-rev__author-wrapper {
  font-weight: bold;
  vertical-align: middle;
}

.jdgm-rev__author {
  vertical-align: middle;
}

.jdgm-rev__location {
  opacity: 0.35;
  vertical-align: middle;
}

.jdgm-rev__body > p:last-of-type {
  margin-bottom: 0;
}

.jdgm-rev__pics {
  font-size: 0;
  white-space: nowrap;
  height: auto;
  overflow: auto;
}

.jdgm-rev__vids {
  overflow: auto;
  white-space: nowrap;
}

.jdgm-rev__social {
  float: left;
}

.jdgm-rev__votes {
  float: right;
}

.jdgm-quest,
.jdgm-rev {
  position: relative;
  overflow: hidden;
  border-top: 1px solid #eee;
  padding-top: 15px;
  margin-top: 15px;
}

.product_review::-webkit-scrollbar {
  width: 4px;
}

.product_review::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 35px;
}

.jdgm-rev-widg__summary,
.jdgm-rev-widg__header {
  display: none;
}

.jdgm-rev-widg.jdgm-rev-widg {
  display: block;
  clear: both;
}

/*/======= TMB product review form start  =======/*/
.review_wrapper {
  max-width: 100%;
  width: 100%;
  padding: 18px 24.5px;
  border-top: 1px solid #000;
  margin-top: 8px;
}

.review_rating {
  font-family: 'Helvetica Neue', Arial, sans-serif !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  padding-bottom: 9px;
  display: block;
}

input[type='radio'] {
  accent-color: #d9d9d9;
  border: 1px solid #d9d9d9;
  outline: 0px solid #d9d9d9;
  background: #d9d9d9;
  appearance: none;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  cursor: pointer;
}

input[type='radio']:checked {
  background: #000;
  accent-color: #d9d9d9;
  border: 1px solid #d9d9d9;
  outline: 0px solid #d9d9d9;
}

form.review-dot-form {
  display: flex;
  gap: 10px;
  justify-content: space-between;
}

.review_dot {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 15px;
  gap: 5px;
  cursor: pointer;
}

.review_star {
  display: block;
  cursor: pointer;
  line-height: 0;
}

.review_form label {
  font-family: 'Helvetica Neue', Arial, sans-serif !important;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #000000;
  display: block;
  padding-bottom: 2px;
}

.review_form input {
  display: block;
  outline: none;
  padding: 5px;
  width: 100%;
  line-height: 0;
  font-size: 12px;
  font-family: 'Helvetica Neue', Arial, sans-serif !important;
}

.review_form div {
  margin-bottom: 7px;
}

.reviewDiscription {
  outline: none;
  text-align: left;
  padding: 5px;
  border: 1px solid #000000;
  width: 100%;
  resize: none;
  font-size: 12px;
  font-family: 'Helvetica Neue', Arial, sans-serif !important;
}

.reviewbtn.cta_btn.cta_btn-black {
  color: #fff !important;
  text-transform: uppercase;
  font-family: 'Helvetica Neue', Arial, sans-serif !important;
  cursor: pointer;
}

.reviewbtn.cta_btn.cta_btn-black:hover {
  color: #000 !important;
}

.see_in img {
  width: 78px;
  display: block;
  height: 23px;
}

.review-dot-form {
  display: flex;
  justify-content: space-between;
}

.review_form input[type='radio'] {
  width: auto;
}

/*/======= TMB product review form end  =======/*/

.product_description.product_description-comment .jdgm-rev.jdgm-divider-top {
  border: none;
  margin-top: 0;
  /* display: flex; */
  flex-direction: column-reverse;
  align-items: flex-end;
  display: none;
}

.product_description.product_description-comment .jdgm-rev__icon,
.product_description.product_description-comment .jdgm-divider-top span.jdgm-rev__rating {
  display: none;
}

.product_description.product_description-comment .jdgm-rev.jdgm-divider-top:first-child {
  display: flex;
}

.product_description.product_description-comment .quote_owner .jdgm-rev__body,
.product_description.product_description-comment .quote_owner .jdgm-rev__rating,
.product_description.product_description-comment .quote_owner .jdgm-rev__icon,
.product_description.product_description-comment .jdgm-star {
  display: none;
}

.product_review .jdgm-rev__header {
  display: flex;
  align-items: baseline;
}

.product_description.product_description-comment .quote_owner .jdgm-rev.jdgm-divider-top {
  margin-top: 0;
  padding-top: 0;
}

.product_description.product_description-comment .quote_owner_auth {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
  margin-top: 2px;
}
</style>
